import { useState } from "react";
import { Share2 } from "lucide-react";
import { toast } from "sonner";

/*
 * ShareButton — single button using the Web Share API on mobile (native iOS /
 * Android share sheet), falling back to copying the link on desktop.
 */
export default function ShareButton({
  url,
  title = "Metamorph by George Maple",
  text = "Metamorph by George Maple",
  testid = "share-button",
}) {
  const [busy, setBusy] = useState(false);
  const shareUrl = url || (typeof window !== "undefined" ? window.location.href : "");

  const onClick = async () => {
    if (busy) return;
    setBusy(true);
    try {
      if (typeof navigator !== "undefined" && navigator.share) {
        await navigator.share({ title, text, url: shareUrl });
      } else if (typeof navigator !== "undefined" && navigator.clipboard) {
        await navigator.clipboard.writeText(shareUrl);
        toast.success("Link copied — share it anywhere.");
      } else {
        toast.message(shareUrl);
      }
    } catch (err) {
      // User cancelled the share sheet — ignore. Anything else surfaces.
      if (err && err.name !== "AbortError") {
        toast.error("Couldn't share. Copy the URL from the address bar.");
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={busy}
      className="btn-line inline-flex items-center gap-2 disabled:opacity-50"
      aria-label="Share"
      data-testid={testid}
    >
      <Share2 className="w-3.5 h-3.5" strokeWidth={1.2} />
      Share
    </button>
  );
}
